import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { autom2plataformaApiRef } from './api/Autom2PlataformaApi';
import { Autom2PlataformaClient } from './api/Autom2PlataformaClient';

export const autom2plataformaPlugin = createPlugin({
  id: 'autom2plataforma',
  apis: [
    createApiFactory({
      api: autom2plataformaApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new Autom2PlataformaClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

/**
 * "IaC" tab content for the Application entity page.
 *
 * Mounts the tab's own router, not a single page: the tab holds the listing at
 * its index route and one outputs page per infrastructure underneath.
 */
export const EntityIacContent = autom2plataformaPlugin.provide(
  createRoutableExtension({
    name: 'EntityIacContent',
    component: () => import('./components/IacRouter').then(m => m.IacRouter),
    mountPoint: rootRouteRef,
  }),
);
